import { useOutletContext } from "react-router-dom";
import { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";

import { translations } from "./../../i18/translations.js";

const VerifyJuniorRegistration = () => {

    const API_URL = process.env.REACT_APP_SERVICE_API_URL;
    var {token} = useParams();

    const {lang} = useOutletContext();

    const [regState, setRegState] = useState(null);

    useEffect(() => {
        const verify = async () => {
            try {
                const payload = {
                    token: token
                };

                const response = await fetch(`${API_URL}/common/verify_junior.php`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                });
                const data = await response.json();
                setRegState(data);
            } catch (error) {
                console.error('Error fetching content:', error);
            }
        };
        verify();
    }, []);

    return (
            <>
            <h1 className="mbkegy-content">{translations[lang].junior_reg_verification}</h1>
            {!regState && <span>{translations[lang].junior_reg_verification_inprogress}</span>}
            {regState && <span>{translations[lang].junior_reg_verification_done}</span>}
            </>
            );
};

export default VerifyJuniorRegistration;